import React from 'react';

import { ChartContent } from '../../../Chart';

const TreeMapView = ({
  chartRef,
  options,
  isNoData,
  useSmallNoDataMessage,
}: {
  chartRef: React.MutableRefObject<any>;
  options: Highcharts.Options;
  isNoData: boolean;
  useSmallNoDataMessage: boolean;
}) => {
  return (
    <ChartContent
      options={options}
      chartRef={chartRef}
      noDataToDisplay={isNoData}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default TreeMapView;
